import React, { Component } from 'react';
import { Modal, Input, Icon, DatePicker, message, Select,Button ,Upload, Tooltip} from 'antd';
import Text from '../../../basicElement/Text';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import dictCache from '../../../../common/dictCache';
import SearchRetrieve from "../../../common/SearchRetrieve.new";
import $ from '../../../../common/AjaxRequest';
import { xToken } from '../../../../common/AjaxRequest';
import moment from 'moment';

const Option = Select.Option;
const dateFormat = "YYYY-MM-DD";
const { TextArea } = Input;
const {RangePicker} = DatePicker

const STATUS = {
    add: {
        add: true,
        title: '核查信息登记',
    },
    edit: {
        edit: true,
        title: '核查信息修改',
    },
}
class Update extends Component {
    state = {
        visible:false,
        fileRemove:false,//bug:33451暂时解决方法
        seveParams:{},
        modelTtpe:'add',
        verifyAgencyList:[],
        verifyConfigureList:[],
        investigationSiteList:[],
        siteList:[
            {
                siteListIndex:Date.now(),
                fileIdList:[],
                fileList:[]
            },
        ]
    }

    componentDidMount(){
        this.queryVerificationInstitutions()
    }

    show = (status,record) =>{
        const modelTtpe =  status;
        if(modelTtpe == 'edit'){    
            this.queryShowData(record)
        }
        this.setState({
            visible:true,
            modelTtpe,
            record
        },()=>{
            if(modelTtpe == 'edit'){
                this.loadedFileList(
                    this.loadContractFileList(),
                );
            }
        })
    }
    //修改时获取表单数据
    queryShowData = (record)=>{
        const {seveParams,siteList} = this.state;
        const {
            investigationId,
            investigationName,
            verifyAgencyId,
            verifyAgencyRemark,
            investigationSiteId,
            investigationSiteName,
            departmentName,
            areaName,
            city,
            siteRandomAmount,
            verifyResultId,
            verifyContent,
            planVerifyDateBegin,
            planVerifyDateEnd,
            actualVerifyDateBegin,
            actualVerifyDateEnd
        } = record
        seveParams.investigationId=investigationId || undefined;
        seveParams.investigationName=investigationName || undefined;
        seveParams.verifyAgencyId=verifyAgencyId || undefined;
        seveParams.verifyAgencyRemark=verifyAgencyRemark || undefined;
        siteList[0].investigationSiteId=investigationSiteId || undefined;
        siteList[0].investigationSiteName=investigationSiteName || undefined;
        siteList[0].departmentName=departmentName;
        siteList[0].areaName=areaName || undefined;
        siteList[0].areaName=areaName || undefined;
        siteList[0].city=city || undefined;
        siteList[0].siteRandomAmount=siteRandomAmount || undefined;
        siteList[0].verifyResultId=verifyResultId || undefined;
        siteList[0].verifyContent=verifyContent || undefined;
        siteList[0].planVerifyDateBeginStr=planVerifyDateBegin || undefined;
        siteList[0].planVerifyDateEndStr=planVerifyDateEnd || undefined;
        siteList[0].actualVerifyDateBeginStr=actualVerifyDateBegin || undefined;
        siteList[0].actualVerifyDateEndStr=actualVerifyDateEnd || undefined;
        this.setState({seveParams,siteList})
    }
    
    queryVerificationInstitutions = () => {
        dictCache.getDict('NATION_VERIFY_CONFIG', cb => {
            Fetch.post(API_URL.nationalverification.queryConfigureList).then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            const {verifyAgencyList ,verifyConfigureList} = res;
            this.setState({verifyAgencyList ,verifyConfigureList})
        });
    }

    queryInvestigationSiteByKeyword =(id)=>{
        Fetch.post(API_URL.investigation.queryInvestigationSiteByKeyword,{
            limit: 9999,
            invId:id, 
            type:'getSiteRandom'
        }).then(res => {
            const {datas} = res.data.siteList;
            this.setState({investigationSiteList:datas})
        }).catch(error => {
            console.error(error);
        });
    }
    
    handleSubmitData = () =>{
        const { siteList } = this.state;
        const newSiteList = {}
        siteList.forEach((e,i)=>{
            for (const key in e) {
                if(key !== 'fileList'){
                    if(key !== 'fileIdList'){
                        newSiteList['siteList['+i+'].'+key]=e[key];
                    }else{
                        e[key].forEach((file , index)=>{
                            newSiteList['siteList['+i+'].fileIdList['+index+']']=file;
                        })
                    }
                }
            }
        })
        return newSiteList
    }

    submit = () =>{
        const { seveParams , siteList, record ,modelTtpe} = this.state;
        const { investigationId , verifyAgencyId ,verifyAgencyRemark } = seveParams;
        if(!investigationId){
            return message.warning('请选择项目简称！');
        }
        if(!verifyAgencyId){
            return message.warning('请选择核查机构！');
        }
        if(verifyAgencyId == 5 && !verifyAgencyRemark){
            return message.warning('请填写其他机构备注说明！');
        }
        for(let i = 0;i<siteList.length;i++){
            const { 
                investigationSiteId ,
                investigationSiteName ,
                planVerifyDateBeginStr,
                planVerifyDateEndStr,
                actualVerifyDateBeginStr,
                actualVerifyDateEndStr,
                verifyResultId, 
                verifyContent
            } = siteList[i];
            if(!investigationSiteId){
                return message.warning('请选择被核查研究中心！');
            }
            if(!planVerifyDateBeginStr){
                return message.warning('请选择被核查研究中心为：“'+investigationSiteName+'”下的计划核查时间！');
            }
            if(!actualVerifyDateBeginStr && (verifyResultId == 2 || verifyResultId == 3)){
                return message.warning('请选择被核查研究中心为：“'+investigationSiteName+'”下的实际核查时间！');
            }
            // if(!verifyResultId){
            //     return message.warning('请选择被核查研究中心为：“'+investigationSiteName+'”下的核查结构！');
            // }
            if(!verifyContent){
                return message.warning('请选填写被核查研究中心为：“'+investigationSiteName+'”下的主要核查问题！');
            }else if(i == siteList.length-1 ){
                const siteListData = this.handleSubmitData();
                const options = {
                    url: `${API_URL.nationalverification.saveNationVerify}`,
                    data: {
                        investigationId,
                        verifyAgencyId,
                        verifyAgencyRemark,
                        ...siteListData,
                        nationVerifyId:modelTtpe=='edit'?record.nationVerifyId:null
                    },
                    dataType: 'json',
                    doneResult: (res => {
                        message.success(res.success);
                        this.cancel();
                        this.props.loadData()
                    }),
                    errorResult: (err => {
                        message.warning(err.error);
                    }),
                };
                $.sendRequest(options);
            }
        }
    }

    handleChange = (value, key ,index) =>{
        const { seveParams , siteList} = this.state;
        switch (key) {
            case 'investigation': {
                const { value: id, text: name } = value;
                    seveParams[`${key}Id`] = id;
                    seveParams[`${key}Name`] = name;
                if(!id){
                    const resetSiteList =[
                        {
                            siteListIndex:Date.now(),
                            fileIdList:[],
                            fileList:[]
                        },
                    ]
                    seveParams.investigationSiteList=[]
                    this.setState({seveParams ,siteList:[...resetSiteList]});
                    break;
                }
                this.queryInvestigationSiteByKeyword(id)
                this.setState({seveParams});
                break;
            }
            case 'verifyAgencyId':{
                seveParams[key] = value;
                if(value != 5){
                    seveParams['verifyAgencyRemark'] = '';
                }
                this.setState({seveParams});
                break;
            }
            case 'verifyAgencyRemark':{
                seveParams[key] = value;
                this.setState({seveParams});
                break;
            }
            case 'investigationSite':{
                const { value: id, text: name,areaName,departmentName,city,siteRandomAmount } = value;
                siteList[index][`${key}Id`] = id;
                siteList[index][`${key}Name`] = name;
                siteList[index][`areaName`] = areaName;
                siteList[index][`departmentName`] = departmentName;
                siteList[index][`city`] = city;
                siteList[index][`siteRandomAmount`] = siteRandomAmount;
                this.setState({siteList});
                break;
            }
            case 'verifyResultId':{
                siteList[index][key] = value;
                this.setState({siteList});
                break;
            }
            case 'verifyContent':{
                siteList[index][key] = value;
                this.setState({siteList});
                break;
            }
            default: {
                seveParams[key] = value;
                this.setState({seveParams});
                break;
            }
        }
    }
    handleDateChange = (date, dateString, key, index)=>{
        const { siteList } = this.state;
        switch (key){
            case 'planVerifyDate':{
                const beginDate = dateString[0];
                const endDate = dateString[1];
                siteList[index].planVerifyDateBeginStr = beginDate;
                siteList[index].planVerifyDateEndStr = endDate;
                // siteList[index].actualVerifyDateBeginStr = beginDate;
                // siteList[index].actualVerifyDateEndStr = endDate;
                this.setState({siteList})
                break;
            }
            case 'actualVerifyDate':{
                const beginDate = dateString[0];
                const endDate = dateString[1];
                siteList[index].actualVerifyDateBeginStr = beginDate;
                siteList[index].actualVerifyDateEndStr = endDate;
                this.setState({siteList})
                break;
            }
        }
    }

    handleUploadChange = (info , index ) => {
        const {siteList , fileRemove} = this.state;
        const fileList = info.fileList.filter((file,index) => {
            const { status, response } = file;
            if (status === 'error') {
                message.error('上传附件失败');
                return false;
            } else if (status === 'done') {
                if (response.error) {
                    message.error(response.error);
                    return false;
                } else if(index == info.fileList.length-1 && !fileRemove){
                    message.success(response.success);
                    return true;
                }
            }
            return true;
        });
        this.setState({fileRemove:false});
        siteList[index].fileList = fileList;
        const fileIdList = [];
        fileList.forEach( i =>{
            i.response?fileIdList.push(i.response.fileMetaId):null
        })
        siteList[index].fileIdList = fileIdList;
        this.setState({ siteList });
    }

    handleRemove = file => {
        this.setState({fileRemove:true})
        const { isCopy, deletable } = file;
        if (isCopy) {
            return;
        } else if (deletable === false) {
            return false;
        }
        Fetch.post(API_URL.nationalverification.deleteEnclosureFile, {
            fileMetaId: file.response?file.response.fileMetaId:file.fileMateId
        }).then(res => {
            message.success(res.success);
        }).catch(error => message.success(error));
    }

    beforeUpload = (file , index) => {
        const { siteList } = this.state;
        const isLt30M = file.size / 1024 / 1024 <= 30;
        if (siteList[index].fileIdList.length >= 10) {
            message.warning('最多上传10个附件');
            return false;
        }
        if (!isLt30M) {
            message.warning('文件大小不能超过30M');
            return false;
        }
    }

    // 处理合同附件、当前附件
    loadedFileList = (...promises) => {
        const {siteList} = this.state
        Promise.all(promises).then(res => {
            // 兼容360
            const flat = [].flat ? [].flat : [].flatten;
            const fileList = flat.call(res || []);
            siteList[0].fileList=fileList;
            const fileIdList = [];
            fileList.forEach( i =>{
                fileIdList.push(i.fileMateId);
            })
            siteList[0].fileIdList = fileIdList;
            this.setState({ siteList });
        }).catch(error => {
            console.error(error);
        })
    }

    loadContractFileList = () => {
        const { record: { nationVerifySiteId } } = this.state;
        return Fetch.post(API_URL.nationalverification.queryEnclosureFileList, {
            relateId:nationVerifySiteId,
            uploadType:"NATION_VERIFY_SITE"
        }).then(res => {
            const fileList = res.datas || [];
            fileList.forEach((item, index) => {
                item.uid = item.fileMateId;
            });
            return fileList;
        });
    }

    addAuditCenter = () =>{
        const {siteList , investigationSiteList} = this.state;
        // const {
        //     investigationSiteId ,
        //     investigationSiteName ,
        //     planVerifyDateBeginStr,
        //     planVerifyDateEndStr,
        //     actualVerifyDateBeginStr,
        //     actualVerifyDateEndStr,
        //     verifyResultId, 
        //     verifyContent
        // } = siteList[siteList.length-1];
        // if(!investigationSiteId){
        //     return message.warning('')
        // }
        if(siteList.length<investigationSiteList.length){
            siteList.push({
                siteListIndex:Date.now(),
                fileIdList:[],
                fileList:[]
            })
            this.setState({siteList})
        }else{
            message.warning('无可选被核查研究中心！！')
        }
        
    }
    
    delAuditCenter = (id)=>{
        const {siteList} = this.state;
        siteList.forEach( (text,index)=>{
            if(text.siteListIndex == id){
                siteList.splice(index,1)
            }
        })
        this.setState({siteList})
    }

    createAuditCenter = ()=>{
        const { seveParams ,siteList ,verifyConfigureList} = this.state;
        const {
            investigationId
        } = seveParams
        //核查结果
        const verifyConfigureOption = verifyConfigureList.map(i => <Option key={i.configureType} value={i.nationVerifyConfigureId}>{i.configureValue}</Option>);
        const auditCenterModle = siteList.map((i,index) => {
            const investigationSiteSelectedList =[]
            siteList.forEach(e=>{
                e.investigationSiteId?investigationSiteSelectedList.push(e.investigationSiteId):''
            })
            return(
                <div className='auditCenter'>
                    <Icon 
                        type="close-circle"
                        className='delBtn'
                        style={{
                        display:siteList.length>1?'block':'none'}} 
                        onClick={()=>this.delAuditCenter(i.siteListIndex)}
                        />
                    <div className='auditCenter_line'>
                        <div className="item">
                            <label className="ui-label" ><Text asterisk={true} colon={true}>被核查研究中心</Text></label>
                            <span className="ui-text">
                                <SearchRetrieve
                                disabled={!investigationId}
                                keyword="investigationSite"
                                style={{ width: 260 }}
                                placeholder="输入中心名称/编号检索"
                                params={{ limit: 9999,invId:investigationId ,type:'getSiteRandom'}}
                                selectedList={investigationSiteSelectedList}
                                value={i.investigationSiteName}
                                url={API_URL.investigation.queryInvestigationSiteByKeyword}
                                config={{ id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', type: 'site', show: 'invSite' }}
                                onChange={value => this.handleChange(value, 'investigationSite',index)}
                            />
                            </span>
                        </div>
                        <div className="item">
                            <label className="ui-label" >科室：</label>
                            <span className="ui-text text"  >
                                {i.departmentName}
                            </span>
                        </div>
                    </div>
                    <div className='auditCenter_line'>
                        <div className="item">
                            <label className="ui-label" >区域：</label>
                            <span className="ui-text text" >
                                {i.areaName}
                            </span>
                        </div>
                        <div className="item">
                            <label className="ui-label" >城市：</label>
                            <span className="ui-text text" >
                                {i.city}
                            </span>
                        </div>
                    </div>
                    <div className='auditCenter_line'>
                        <div className="item">
                            <label className="ui-label" >实际入组例数：</label>
                            <span className="ui-text text" >
                                {i.siteRandomAmount}
                            </span>
                        </div>
                        <div className="item">
                            <label className="ui-label" ><Text asterisk={true} colon={true}>计划核查时间</Text></label>
                            <span className="ui-text text" >
                                {  
                                    <RangePicker value={[i.planVerifyDateBeginStr?moment(i.planVerifyDateBeginStr,dateFormat):null,i.planVerifyDateEndStr?moment(i.planVerifyDateEndStr,dateFormat):null]}onChange={(date, dateString) => this.handleDateChange(date, dateString ,'planVerifyDate', index)} />
                                }
                            </span>
                        </div>
                    </div>
                    <div className='auditCenter_line'>
                        <div className="item">
                            <label className="ui-label" ><Text asterisk={(i.verifyResultId == 2 || i.verifyResultId == 3)} colon={true}>实际核查时间</Text></label>
                            <span className="ui-text text" >
                                {
                                    <RangePicker 
                                        disabledDate ={(current)=> {return current && current.valueOf() > Date.now()}}
                                        value={[i.actualVerifyDateBeginStr?moment(i.actualVerifyDateBeginStr,dateFormat):null,i.actualVerifyDateEndStr?moment(i.actualVerifyDateEndStr,dateFormat):null]}
                                        onChange={(date, dateString) => this.handleDateChange(date, dateString ,'actualVerifyDate' , index)} 
                                    />
                                }
                            </span>
                        </div>
                        <div className="item">
                            <label className="ui-label" ><Text colon={true}>核查结果</Text></label>
                            <span className="ui-text">
                                <Select
                                    allowClear={true}
                                    style={{width:'260px'}}
                                    placeholder="请选择"
                                    value={i.verifyResultId || null}
                                    onChange={value => this.handleChange(value, 'verifyResultId' , index)}
                                >
                                    {verifyConfigureOption}
                                </Select>
                            </span>
                        </div>
                    </div>
                    <div className='auditCenter_line'>
                        <div className="item">
                            <label className="ui-label" ><Text asterisk={true} colon={true}>主要核查问题</Text></label>
                            <span className="ui-text text" >
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 260 }}
                                    value={siteList[index].verifyContent}
                                    maxLength="1000"
                                    onChange={e => this.handleChange(e.target.value, 'verifyContent' , index)}
                                />
                            </span>
                        </div>
                        <div className="item">
                            <label className="ui-label" style={{verticalAlign:'top'}}><Text colon={true}>如有附件可上传</Text></label>
                            <span className="ui-text">
                                <Upload
                                    action={API_URL.nationalverification.uploadEnclosureFile}
                                    data={{
                                        path: Date.now(),
                                        curUserId: sessionStorage.userId,
                                        curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                        uploadType:'NATION_VERIFY_SITE',
                                    }}
                                    beforeUpload={(file) =>this.beforeUpload(file,index)}
                                    onChange={(file) =>this.handleUploadChange(file,index)}
                                    onRemove={(file) =>this.handleRemove(file)}
                                    fileList={i.fileList}
                                    headers={xToken}
                                >
                                    <Button style={{ width: 80 }}>选择文件</Button>
                                </Upload>
                            </span>
                        </div>
                    </div>
                </div>
            )
        })
        return auditCenterModle
    }

    getContent = () => {
        const { seveParams,verifyAgencyList } = this.state;
        const {
            investigationName,
            verifyAgencyId,
            verifyAgencyRemark,
        } = seveParams
        //核查机构
        const verifyAgencyOption = verifyAgencyList.map(i => <Option key={i.verifyAgencyId} value={i.verifyAgencyId}>
                <Tooltip placement="right" title={i.agencyName}>
                    <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{i.agencyName}</span>
                </Tooltip>
            </Option>);
        return(
            <div style={{padding:'10px 20px'}}>
                <div className='line' >
                    <div className="item">
                        <label className="ui-label"><Text asterisk={true} colon={true}>项目简称</Text></label>
                        <span className="ui-text">
                            <SearchRetrieve
                                keyword="investigationName"
                                style={{ width: 260 }}
                                placeholder="输入项目简称自动检索"
                                params={{ limit: 20 }}
                                value={investigationName}
                                url={API_URL.nationalverification.queryInvForNationVerifyAdd}
                                config={{ id: "investigationId", name: "investigationName" }}
                                onChange={value => this.handleChange(value, 'investigation')}
                            />
                        </span>
                    </div>
                    <div className="item">
                        <label className="ui-label" ><Text asterisk={true} colon={true}>核查机构</Text></label>
                        <span className="ui-text">
                            <Select
                                allowClear={true}
                                style={{width:'260px'}}
                                placeholder="请选择"
                                value={seveParams.verifyAgencyId}
                                onChange={value => this.handleChange(value, 'verifyAgencyId')}
                            >
                                {verifyAgencyOption}
                            </Select>
                        </span>
                    </div>
                </div>
                {
                    (verifyAgencyId == 5 )&&
                    <div className='line' >
                        <div className="item">
                            <label className="ui-label" ><Text asterisk={true} colon={true}>其他机构备注说明</Text></label>
                            <span className="ui-text text" >
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 260 }}
                                    maxLength="1000"
                                    value={verifyAgencyRemark}
                                    onChange={e => this.handleChange(e.target.value, 'verifyAgencyRemark')}
                                />
                            </span>
                        </div>
                    </div>
                }
                {
                    this.createAuditCenter()
                }
                <div className="preview-item">
                    <Button type="primary" style={{ width:140 }} onClick={() => this.addAuditCenter()}>添加被审核中心</Button>
                </div>
            </div>
        )
    }

    getEditContent = ()=>{
        const { 
            seveParams,
            verifyAgencyList, 
            record,
            siteList,
            verifyConfigureList
        } = this.state;
        const {
            investigationId,
            investigationName,
            verifyAgencyId,
            verifyAgencyRemark,
            investigationSiteId,
            investigationSiteName,
            departmentName,
            areaName,
            city,
            siteRandomAmount,
            verifyResultId,
            verifyContent,
            planVerifyDateBegin,
            planVerifyDateEnd,
            actualVerifyDateBegin,
            actualVerifyDateEnd
        } = record
        //核查机构
        const verifyAgencyOption = verifyAgencyList.map(i => <Option key={i.verifyAgencyId} value={i.verifyAgencyId}>{i.agencyName}</Option>);
        //核查结果
        const verifyConfigureOption = verifyConfigureList.map(i => <Option key={i.configureType} value={i.nationVerifyConfigureId}>{i.configureValue}</Option>);
        return(
            <div style={{padding:'10px 20px'}}>
                <div className='edit_line' >
                    <div className="item">
                        <label className="ui-label">项目简称：</label>
                        <span className="ui-text">
                            {investigationName}
                        </span>
                    </div>
                    <div className="item">
                        <label className="ui-label" ><Text asterisk={true} colon={true}>核查机构</Text></label>
                        <span className="ui-text">
                            <Select
                                allowClear={true}
                                style={{width:'260px'}}
                                placeholder="请选择"
                                value={seveParams.verifyAgencyId}
                                onChange={value => this.handleChange(value, 'verifyAgencyId')}
                            >
                                {verifyAgencyOption}
                            </Select>
                        </span>
                    </div>
                </div>
                {
                    (seveParams.verifyAgencyId == 5 )&&
                    <div className='edit_line' >
                        <div className="item">
                            <label className="ui-label" ><Text asterisk={true} colon={true}>其他机构备注说明</Text></label>
                            <span className="ui-text text" >
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 260 }}
                                    defaultValue={verifyAgencyRemark}
                                    value={seveParams.verifyAgencyRemark}
                                    onChange={e => this.handleChange(e.target.value, 'verifyAgencyRemark')}
                                />
                            </span>
                        </div>
                    </div>
                }
                <div className='edit_line'>
                        <div className="item">
                            <label className="ui-label" >被核查研究中心：</label>
                            <span className="ui-text">
                                {investigationSiteName}
                            </span>
                        </div>
                        <div className="item">
                            <label className="ui-label" >科室：</label>
                            <span className="ui-text text"  >
                                {departmentName}
                            </span>
                        </div>
                    </div>
                    <div className='edit_line'>
                        <div className="item">
                            <label className="ui-label" >区域：</label>
                            <span className="ui-text text" >
                                {areaName}
                            </span>
                        </div>
                        <div className="item">
                            <label className="ui-label" >城市：</label>
                            <span className="ui-text text" >
                                {city}
                            </span>
                        </div>
                    </div>
                    <div className='edit_line'>
                        <div className="item">
                            <label className="ui-label" >实际入组例数：</label>
                            <span className="ui-text text" >
                                {siteRandomAmount}
                            </span>
                        </div>
                        <div className="item">
                            <label className="ui-label" ><Text asterisk={true} colon={true}>计划核查时间</Text></label>
                            <span className="ui-text text" >
                                {   
                                    <RangePicker
                                    value={[siteList[0].planVerifyDateBeginStr?moment(siteList[0].planVerifyDateBeginStr,dateFormat):null,siteList[0].planVerifyDateEndStr?moment(siteList[0].planVerifyDateEndStr,dateFormat):null]}
                                    defaultValue={[moment(planVerifyDateBegin,dateFormat),moment(planVerifyDateEnd,dateFormat)]}
                                    onChange={(date, dateString) => this.handleDateChange(date, dateString ,'planVerifyDate', 0)} />
                                }
                            </span>
                        </div>
                    </div>
                    <div className='edit_line'>
                        <div className="item">
                            <label className="ui-label" ><Text asterisk={(siteList[0].verifyResultId == 2 || siteList[0].verifyResultId == 3)} colon={true}>实际核查时间</Text></label>
                            <span className="ui-text text" >
                                {
                                    <RangePicker 
                                    value={[siteList[0].actualVerifyDateBeginStr?moment(siteList[0].actualVerifyDateBeginStr,dateFormat):null,siteList[0].actualVerifyDateEndStr?moment(siteList[0].actualVerifyDateEndStr,dateFormat):null]}
                                    disabledDate ={(current)=> {return current && current.valueOf() > Date.now()}}
                                    defaultValue={[moment(actualVerifyDateBegin,dateFormat),moment(actualVerifyDateEnd,dateFormat)]}
                                    onChange={(date, dateString) => this.handleDateChange(date, dateString ,'actualVerifyDate' , 0)} />
                                }
                            </span>
                        </div>
                        <div className="item">
                            <label className="ui-label" ><Text colon={true}>核查结果</Text></label>
                            <span className="ui-text">
                                <Select
                                    allowClear={true}
                                    style={{width:'260px'}}
                                    placeholder="请选择"
                                    value={siteList[0].verifyResultId}
                                    // value={siteList[0].verifyResultId?siteList[0].verifyResultId:verifyResultId}
                                    onChange={value => this.handleChange(value, 'verifyResultId' , 0)}
                                >
                                    {verifyConfigureOption}
                                </Select>
                            </span>
                        </div>
                    </div>
                    <div className='edit_line' style={{minHeight:'100px'}}>
                        <div className="item">
                            <label className="ui-label" ><Text asterisk={true} colon={true}>主要核查问题</Text></label>
                            <span className="ui-text text" >
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 260 }}
                                    value={siteList[0].verifyContent}
                                    onChange={e => this.handleChange(e.target.value, 'verifyContent' , 0)}
                                />
                            </span>
                        </div>
                        <div className="item">
                            <label className="ui-label" style={{verticalAlign:'top'}}><Text colon={true}>如有附件可上传</Text></label>
                            <span className="ui-text">
                                <Upload
                                    action={API_URL.nationalverification.uploadEnclosureFile}
                                    data={{
                                        path: Date.now(),
                                        curUserId: sessionStorage.userId,
                                        curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                        uploadType:'NATION_VERIFY_SITE',
                                    }}
                                    beforeUpload={(file) =>this.beforeUpload(file,0)}
                                    onChange={(file) =>this.handleUploadChange(file,0)}
                                    onRemove={(file) =>this.handleRemove(file)}
                                    fileList={siteList[0].fileList}
                                    headers={xToken}
                                >
                                    <Button style={{ width: 80 }}>选择文件</Button>
                                </Upload>
                            </span>
                        </div>
                    </div>
            </div>
        )
    }

    cancel = () =>{
        this.setState({
            visible: false,
            seveParams:{},
            siteList:[
                {
                    siteListIndex:Date.now(),
                    fileIdList:[],
                    fileList:[]
                },
            ]
        });
    }

    render() {
        const { modelTtpe ,visible } = this.state
        return (
            <Modal
                title={STATUS[modelTtpe].title}
                visible={visible}
                onOk={this.submit}
                onCancel={this.cancel}
                className="preview-modal"
                width="900px"
                maskClosable={false}
                bodyStyle={{ maxHeight: 500 }}
            >
                <div className="cont-cont">
                    {
                    modelTtpe =='add'?
                    this.getContent():
                    this.getEditContent()}
                </div>
            </Modal>
        );
    }
}

export default Update;



// WEBPACK FOOTER //
// ./src/components/qualityManagement/Nationalverification/components/Update.js